import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import { ACHBatch, ACHTemplate, OneTimeACHPayment, Participant } from "model";

/**
* @class ACHToParticipant
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.achToParticipants[0];
* const contactInfo = new ACHToParticipant(record);
* @property {NUMBER} _id - The id of the ACHToParticipant.
*/
export default class ACHToParticipant extends BCMSRecord {
    _id
    _participant
    _notify
    _oneTimeACHPayment
    _achTemplate
    _amount
    _addenda
    _hold
    _prenote
    _numberOfDistributions

    constructor (record){     
      super(record) 
    }
  }

  ACHToParticipant.define({
    "recordType": "achToParticipants",
    "recordIDProp": "id",
    "className" : "ACHToParticipant",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

      /** 
       * @name participant
       * @instance
       * @property get {STRING} - gets the account value
       * @property set {STRING} - sets the account value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToClass("participant", "_participant", () => Participant),

      /** 
       * @name notify
       * @instance
       * @property get {STRING} - gets the notify value
       * @property set {STRING} - sets the notify value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToString("notify", "_notify"),

      /** 
       * @name oneTimeACHPayment
       * @instance
       * @property get {STRING} - gets the oneTimeACHPayment value
       * @property set {STRING} - sets the oneTimeACHPayment value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToClass("oneTimeACHPayment", "_oneTimeACHPayment", () => ACHBatch),

      /** 
       * @name achTemplate
       * @instance
       * @property get {STRING} - gets the achTemplate value
       * @property set {STRING} - sets the achTemplate value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToClass("achTemplate", "_achTemplate", () => ACHTemplate),

       /** 
       * @name amount
       * @instance
       * @property get {STRING} - gets the amount value
       * @property set {STRING} - sets the amount value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToCurrency("amount", "_amount"),

      /** 
       * @name addenda
       * @instance
       * @property get {STRING} - gets the addenda value
       * @property set {STRING} - sets the addenda value
       * @memberof ACHToParticipant
       */
      BCMSRecordProperty.mapToString("addenda", "_addenda"),

      /** 
       * @name hold
       * @instance
       * @property get {STRING} - gets the hold of the template
       * @property set {STRING} - sets the hold of the template
       * @memberof ACHTemplate
       */
      BCMSRecordProperty.mapToBoolean("hold","_hold"),

      /** 
       * @name prenote
       * @instance
       * @property get {STRING} - gets the prenote of the template
       * @property set {STRING} - sets the prenote of the template
       * @memberof ACHTemplate
       */
      BCMSRecordProperty.mapToBoolean("prenote","_prenote"),

      /** 
       * @name numberOfDistributions
       * @instance
       * @property get {STRING} - gets the numberOfDistributions of the template
       * @property set {STRING} - sets the numberOfDistributions of the template
       * @memberof ACHTemplate
       */
      BCMSRecordProperty.mapToString("numberOfDistributions","_numberOfDistributions"),

    ]  
})




